export const extractAndFormatPercentage = (input: string): string => {
  if (!input) return '';
  const percentageRegex = /(\d+(\.\d+)?)%/;

  const match = input.match(percentageRegex);

  if (match && match[1]) {
    return match[1];
  } else {
    return '';
  }
};
